import { XMarkIcon } from '@heroicons/react/24/solid';
import useConfirmation from '../../../utils/useConfirmation';
import { useTranslation } from 'react-i18next';
import Notify from '../../../utils/useNotify';
import { useRefresh } from '../../../utils/RefreshProvider';
import axios from 'axios';

export default function RemoveComment({ review_id }) {
  const { t } = useTranslation();
  const { triggerRefresh } = useRefresh();
  const token = localStorage.getItem('token');
  const localhost = process.env.REACT_APP_LOCALHOST;
  const { open, ConfirmComponent } = useConfirmation();

  const handleDelete = async () => {
    await axios.delete(localhost + "review/" + review_id, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        triggerRefresh();
        Notify('success', t("delete-review-success"));
      }).catch((err) => Notify('error', t("delete-review-error")));
  };

  const handleAction = () => {
    open(
      {
        title: t("delete-confirmation-header"),
        text: t("delete-confirmation-body"),
        action: "add",
      },
      handleDelete
    );
  };
  return (
    <>
      {ConfirmComponent}
      <button onClick={handleAction} className="flex-none ml-4 text-black/80 hover:text-black hover:bg-black/5 rounded-sm p-0.5 transition-colors">
        <XMarkIcon className='size-[18px]' />
      </button>

    </>
  )
}
